import styled from '@emotion/styled'
import { Box, Typography } from '@mui/material'
import { colors, typography, palette } from '@resiliatech/birdsong'

export const ProgressChartContainer = styled(Box)`
  display: flex;
  flex-direction: column;
  gap: 16px;
`

export const HeaderContainer = styled(Box)`
  align-items: flex-start;
  display: flex;
  justify-content: space-between;
`

export const Header = styled(Typography)`
  ${typography.up1.regularSans}
`

export const Actions = styled(Box)`
  display: flex;
  gap: 16px;
`

export const Chart = styled(Box)`
  background-color: ${colors.background.secondaryBackground};
  height: 600px;
  padding: 20px;
  width: 100%;
`

export const ChartFooter = styled(Typography)`
  color: ${colors.copy.paragraphDark};
  margin-top: 10px;
`

export const Selectors = styled(Box)`
  display: flex;
`

export const DisconnectedCampaign = styled(Box)`
  background-color: ${colors.feedback.errorLight};
  border-radius: 4px;
  display: flex;
  padding: 6px 16px;
  align-items: flex-start;
  align-self: stretch;
`

export const DisconnectedCampaignHeader = styled(Typography)`
  ${typography.baseline.semiBoldSans}
  color: ${palette.error.dark};
`

export const DisconnectedCampaignBody = styled(Typography)`
  ${typography.baseline.regularSans}
  color: ${palette.error.dark};
  line-height: 150%;
`

export const CalculationType = styled(Box)<{
  variant?: 'completed' | 'unassigned' | 'informational'
}>`
  align-items: center;
  background-color: #e5f2ff;
  border-radius: 4px;
  color: ${colors.info.dark};
  display: flex;
  font-size: 16px;
  font-weight: ${typography.up1.semiBoldSans};
  gap: 6px;
  padding: 6px 16px;
  width: 760px;
`

export const StyledAnchor = styled('a')`
  text-decoration: underline;
  cursor: pointer;
`
